import { Typography } from '@mui/material'

import DynamicCrumbs from '../../../shared/components/ui/dashboard-layout/dynamic-crumbs'
import EmployeeRegistrationForm from '../../../shared/components/employee/employee-registration-form'
import { Box } from '@mui/system'

const HrAdd = () => {
  return (
    <>
      <DynamicCrumbs />
      <Typography sx={{ fontSize: '1.5rem', margin: '0.1rem 0 2rem 0' }}>
        Add New Application
      </Typography>

      <Box sx={{ background: '#fff', padding: '1rem 1rem 2rem 1rem' }}>
        <EmployeeRegistrationForm module={'hr'} />
      </Box>
    </>
  )
}
export default HrAdd
